import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-page-not-found',
  standalone: false,
  template: `
    <div class="not-found-container">
      <div class="not-found-content">
        <div class="not-found-left">
        <!-- <a href="{{ browserURLOrigin }}" target="_parent" aria-label="EY Home"> -->
        <a aria-label="EY Home">
            <img src="assets/images/ey-logo.svg" width="80" height="80" alt="Ey logo, lands to digital tax advisor page" />
        </a>
          <div><span class="error-code">404.</span> That's an error.</div>
          <p class="error-message">
            The requested URL {{ pathName}} was not found on this server.<br>
            <!-- <span class="sub-message">That's all we know.</span> -->
          </p>
        </div>
        <!-- <div class="not-found-right">
          <img src="assets/images/robot-404.png" alt="Broken Robot" class="robot-img" />
        </div> -->
      </div>
    </div>
  `,
  styles: [`
    .not-found-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 80vh;
    }
    .not-found-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      max-width: 900px;
    }
    .not-found-left {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      padding-left: 40px;
    }
    .logo {
      width: 120px;
      margin-bottom: 1.5rem;
    }
    .error-code {
      color: #c00;
      font-size: 2.2rem;
      font-weight: bold;
      margin-right: 10px;
    }
    h2 {
      font-size: 1.5rem;
      margin-bottom: 1rem;
      color: #333;
    }
    .error-message {
      font-size: 1.1rem;
      color: #444;
      margin-bottom: 1rem;
    }
    .sub-message {
      color: #888;
      font-size: 1rem;
      margin-top: 0.5rem;
      display: block;
    }
    .not-found-right {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .robot-img {
      width: 220px;
      max-width: 100%;
    }
    @media (max-width: 700px) {
      .not-found-content {
        flex-direction: column;
        align-items: center;
        padding: 0 10px;
      }
      .not-found-left, .not-found-right {
        padding: 0;
        width: 100%;
        justify-content: center;
        align-items: center;
      }
      .robot-img {
        width: 150px;
      }
    }
  `]
})
export class PageNotFoundComponent implements OnInit {
  constructor(private titleService: Title) { }
  browserURLOrigin = window.location.origin;
  pathName = window.location.pathname;
  ngOnInit() {
    this.titleService.setTitle('404 - Not Found Error!!');
    this.browserURLOrigin = window.location.origin;
    this.pathName = window.location.pathname;
  }
}
